import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Header from "./components/Header";
import FooterLinks from "./components/FooterLinks";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import AdminPage from "./pages/AdminPage";
import AdminCategoryPage from "./pages/AdminCategoryPage";
import AdminProductPage from "./pages/AdminProductPage";
import AdminRequestsPage from "./pages/AdminRequestsPage";
import AccountPage from "./pages/AccountPage";
import CheckoutPage from "./pages/CheckoutPage";
import LoginPage from "./pages/LoginPage";
import MyOrdersPage from "./pages/MyOrdersPage";
import ImpressumPage from "./pages/ImpressumPage";
import PrivacyPage from "./pages/PrivacyPage";
import ProductDetailPage from "./pages/ProductDetailPage";
import ProductsPage from "./pages/ProductsPage";

function ProtectedLayout({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <main className="page" data-testid="app-loading">Lade App…</main>;
  if (!user) return <Navigate to="/login" replace />;
  return <><Header />{children}<FooterLinks /></>;
}

function App() {
  useEffect(() => {
    document.title = "Dosa-Shop";
  }, []);

  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/impressum" element={<><ImpressumPage /><FooterLinks /></>} />
          <Route path="/datenschutz" element={<><PrivacyPage /><FooterLinks /></>} />
          <Route path="/" element={<Navigate to="/produkte" replace />} />
          <Route path="/produkte" element={<ProtectedLayout><ProductsPage /></ProtectedLayout>} />
          <Route path="/produkte/:id" element={<ProtectedLayout><ProductDetailPage /></ProtectedLayout>} />
          <Route path="/checkout" element={<ProtectedLayout><CheckoutPage /></ProtectedLayout>} />
          <Route path="/meine-anfragen" element={<ProtectedLayout><MyOrdersPage /></ProtectedLayout>} />
          <Route path="/account" element={<ProtectedLayout><AccountPage /></ProtectedLayout>} />
          <Route path="/admin" element={<ProtectedLayout><AdminPage /></ProtectedLayout>} />
          <Route path="/admin/anfragen" element={<ProtectedLayout><AdminRequestsPage mode="open" /></ProtectedLayout>} />
          <Route path="/admin/anfragen/archiv" element={<ProtectedLayout><AdminRequestsPage mode="archive" /></ProtectedLayout>} />
          <Route path="/admin/kategorien/:id" element={<ProtectedLayout><AdminCategoryPage /></ProtectedLayout>} />
          <Route path="/admin/produkte/:id" element={<ProtectedLayout><AdminProductPage /></ProtectedLayout>} />
        </Routes>
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
